import { createGlobalStyle, css } from 'styled-components';

import colors from './colors';
import shadows from './shadows';

const vars = Object.entries({ ...colors, ...shadows }).map(
  ([name, value]) => css`--${name}: ${value};`,
);

export default createGlobalStyle`${css`
  :root {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-smoothing: antialiased;
    text-size-adjust: none;
    ${vars}
    --primary-25: var(--blue-25);
    --primary-50: var(--blue-50);
    --primary-100: var(--blue-100);
    --primary-200: var(--blue-200);
    --primary-300: var(--blue-300);
    --primary-400: var(--blue-400);
    --primary-500: var(--blue-500);
    --primary-600: var(--blue-600);
    --primary-700: var(--blue-700);
    --primary-800: var(--blue-800);
    --primary-900: var(--blue-900);
    --primary-1000: var(--blue-1000);
    --outlineColor: var(--indigo-300);
    /* used for elements with forced blue borders where outline HAS to be indigo-300 */
    --indigoOutlineColor: var(--indigo-300);
    --reach-combobox: 1;
    --reach-dialog: 1;
    --reach-listbox: 1;
    --reach-menu-button: 1;
    --reach-tooltip: 1;
  }

  body {
    margin: 0;
    background-color: var(--coolGray-50);
    color: var(--coolGray-900);
    font-size: 16px;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell,
      'Open Sans', 'Helvetica Neue', sans-serif;
    line-height: 1.2;
  }

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-weight: normal;
  }

  a {
    color: var(--primary-900);
    text-decoration: none;
    transition: all 250ms ease;
    outline: none;

    &:hover,
    &:focus {
      text-decoration: underline;
    }

    &:focus-visible {
      border-radius: 4px;
      box-shadow: 0 0 0 2px var(--outlineColor);
    }
  }
`}`;
